import * as React from 'react';

import { BookButton } from '../../components/BookButton';

interface IProps {
  url: string;
  canBeBooked: boolean;
  onClick?(): void;
}

export const BookButtonContainer = ({ url, canBeBooked, onClick }: IProps) => {
  const buttonTitle = React.useMemo(() => (canBeBooked ? 'Бронировать онлайн' : 'Проверить даты'), [canBeBooked]);

  return <BookButton title={buttonTitle} offerUrl={url} onClick={onClick} />;
};
